import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  getProduct(query) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      fmod: query
    }

    return Network.execute('GET', 'CWEBS0050A', data);
  },
  getSize(pmod) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pmod
    }

    return Network.execute('GET', 'CWEBS0051A', data);
  },
  getColFamily(pmod) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pmod
    };

    return Network.execute('GET', 'CWEBS0053A', data);    
  },
  getCol(pmod, ptail, pgrp_col) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pmod,
      ptail,
      pgrp_col
    };

    return Network.execute('GET', 'CWEBS0052A', data);    
  },
  getStock(query_data) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      ...query_data
    };

    return Network.execute('GET', 'CWEBS0049A', data);  
  }
}